module.exports = __webpack_public_path__ + "img/menu-board-coq-frit.7613f0a0.webp";